import {
  EPromotionsFormState,
  ESpecialOfferInternalViewModel
} from 'constants/enums';

export const SCHEDULE_FIELD_NAME = 'schedule';

export const MAP_OFFER_MODEL_TO_HAS_ONE_MAIN: Partial<
  Record<ESpecialOfferInternalViewModel, boolean>
> = {
  [ESpecialOfferInternalViewModel.HUGE]: true,
  [ESpecialOfferInternalViewModel.BABA]: true,
  [ESpecialOfferInternalViewModel.PIPA]: true,
  [ESpecialOfferInternalViewModel.BIG_FISH_CASINO]: true,
  [ESpecialOfferInternalViewModel.JACKPOT_SLOTS]: true
};

export const PROMOTIONS_TABS = [
  { label: 'Settings', value: EPromotionsFormState.GENERAL },
  { label: 'Schedule', value: EPromotionsFormState.SCHEDULE }
];
